import { useStore } from "@nanostores/react"

import { persistentAtom } from "@nanostores/persistent"

const roomFormHintClosedAtomName = "room-form-hint-closed"

const roomFormHintClosedAtom = persistentAtom<boolean>(
  roomFormHintClosedAtomName,
  false,
  {
    encode: value => (value === undefined ? "" : JSON.stringify(value)),
    decode: str => (str === "" ? undefined : JSON.parse(str))
  }
)

export function setPersistentRoomFormHintClosed(value: boolean): void {
  roomFormHintClosedAtom.set(value)
}

export function usePersistentRoomFormHintClosed(): boolean | undefined {
  return useStore(roomFormHintClosedAtom)
}
